import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'alg-privacy-area',
  templateUrl: './alg-privacy-area.component.html',
  styleUrls: ['./alg-privacy-area.component.scss']
})
export class AlgPrivacyAreaComponent implements OnInit {
  @Output() public openFullText: EventEmitter<any> = new EventEmitter();

  @Input() id: string = 'privacyarea';

  constructor() { }

  ngOnInit() {
    
  }

  runOpenFullText(): void {
    this.openFullText.emit();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-privacy-area/alg-privacy-area.component.ts